import React, { Component } from 'react';
import PropTypes from 'prop-types';
import { FlatButton } from 'material-ui';
import { getMetadata, getThumbnails } from 'video-metadata-thumbnails';
import { uploadImage } from '../../core/images/upload';

export class VideoButtonPicker extends Component {
  static propTypes = {
    label: PropTypes.any,
    onFile: PropTypes.func.isRequired,
    onDuration: PropTypes.func.isRequired,
    onPreviewImage: PropTypes.func,
    disabled: PropTypes.bool,
    fullWidth: PropTypes.bool,
  };

  onInputChange(e) {
    Array.from(e.target.files).forEach(async (file) => {
      const reader = new FileReader();
      reader.onload = (r) => {
        this.props.onFile(r.target.result);
      };
      reader.readAsDataURL(file);
      const metadata = await getMetadata(file);
      this.props.onDuration(metadata.duration.toString());
      try {
        const thumbnails = await getThumbnails(file, {
          quality: 0.9,
          end: 10,
        });
        if (thumbnails[5]?.blob && this.props.onPreviewImage) {
          const previewFile = new File([thumbnails[5].blob], 'preview.jpg', {
            type: 'image/jpeg',
          });
          const objectPath = await uploadImage(previewFile, {
            feature: 'video-preview',
            contentType: 'image/jpeg',
          });
          this.props.onPreviewImage(objectPath);
        }
      } catch (error) {
        console.error('Preview upload failed', error);
      }
    });
  }

  componentDidMount() {
    if (this.input) {
      this.input.addEventListener('change', this.onInputChange.bind(this), false);
    }
  }

  componentWillUnmount() {
    if (this.input) {
      this.input.removeEventListener('change', this.onInputChange.bind(this), false);
    }
  }

  render() {
    return (
      <FlatButton
        fullWidth={this.props.fullWidth}
        disabled={this.props.disabled}
        style={{ marginTop: 10, marginBottom: 10 }}
        containerElement="label"
        label={this.props.label}
      >
        <input accept="video/*" type="file" ref={(ref) => (this.input = ref)} />
      </FlatButton>
    );
  }
}
